export default {
  namespaced: true,
  state: {
    muteStatus: false,
    settingsStatus: false,
    speechStatus: true,
  },
  getters: {
    muteStatus: state => state.muteStatus,
    settingsStatus: state => state.settingsStatus,
    speechStatus: state => state.speechStatus,
  },
};
